import levels from "#simplified-word-levels" with { type: "json" };

/** The named accessor lets native Metro defer the other script's JSON initialization. */
export function getSimplifiedWordLevels() {
  return levels;
}
